import { createTheme, responsiveFontSizes } from '@material-ui/core/styles';

// Colors taken from the logo: navy background, teal-green fields, gold sun.
export const colors = {
  navy: '#0E2340',
  navyLight: '#1A3558',
  green: '#1F7A5A',
  greenLight: '#2BB58A',
  greenDark: '#155C43',
  gold: '#E3B23C',
  goldDark: '#C99A26',
  sand: '#F4F7F4',
  text: '#1B2A36',
  textMuted: '#5A6B78',
};

const headingFont = '"Montserrat", "Helvetica Neue", Arial, sans-serif';
const bodyFont = '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

let theme = createTheme({
  palette: {
    primary: {
      main: colors.green,
      light: colors.greenLight,
      dark: colors.greenDark,
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: colors.gold,
      dark: colors.goldDark,
      contrastText: colors.navy,
    },
    text: {
      primary: colors.text,
      secondary: colors.textMuted,
    },
    background: {
      default: '#FFFFFF',
      paper: '#FFFFFF',
    },
  },
  shape: {
    borderRadius: 10,
  },
  typography: {
    fontFamily: bodyFont,
    h1: { fontFamily: headingFont, fontWeight: 800, letterSpacing: '-0.02em', lineHeight: 1.1 },
    h2: { fontFamily: headingFont, fontWeight: 700, letterSpacing: '-0.01em', lineHeight: 1.2 },
    h3: { fontFamily: headingFont, fontWeight: 700, lineHeight: 1.25 },
    h4: { fontFamily: headingFont, fontWeight: 700 },
    h5: { fontFamily: headingFont, fontWeight: 700 },
    h6: { fontFamily: headingFont, fontWeight: 700 },
    subtitle1: { lineHeight: 1.6 },
    body1: { lineHeight: 1.65 },
    button: { fontFamily: headingFont, fontWeight: 700, textTransform: 'none', letterSpacing: 0 },
    overline: { fontFamily: headingFont, fontWeight: 700, letterSpacing: '0.12em' },
  },
  props: {
    MuiButton: { disableElevation: true },
    MuiTextField: { variant: 'outlined' },
  },
  overrides: {
    MuiButton: {
      root: { borderRadius: 999, padding: '10px 24px' },
      sizeLarge: { padding: '14px 30px', fontSize: '1rem' },
    },
    MuiPaper: {
      rounded: { borderRadius: 14 },
    },
    MuiOutlinedInput: {
      root: { borderRadius: 10, backgroundColor: '#FFFFFF' },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
